import { PropsWithChildren } from "react";
import { styled } from "@stitches/react";
import { Loader as ForgeLoader, Banner, BannerItem } from "@Forge/dist";

const LoaderContainer = styled("div", {
  padding: 20,
  minHeight: 200,
});
const Loader = ({
  isLoading,
  isError = false,
  errorReason = "",
  displayText,
  children,
}: PropsWithChildren<{
  isLoading: boolean;
  isError?: boolean;
  errorReason?: string;
  displayText: string;
}>) => {
  return isLoading ? (
    <LoaderContainer>
      <ForgeLoader loading={isLoading} fixedCenter={true} text={displayText} />
    </LoaderContainer>
  ) : (
    <>
      {isError ? (
        <Banner alertType="critical">
          <BannerItem headerText="Network Error">{errorReason}</BannerItem>
        </Banner>
      ) : (
        children
      )}
    </>
  );
};

export default Loader;
